import { render, staticRenderFns } from "./RelatieEdit.vue?vue&type=template&id=e9ba6e38"
import script from "./RelatieEdit.vue?vue&type=script&lang=js"
export * from "./RelatieEdit.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RelatieEdit.vue?vue&type=style&index=1&id=e9ba6e38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports